// Module
var code = "<div class=\"sign-in-form\"> <h1>You have been logged out.</h1> <p v-if=\"logoutReason\" class=\"alert\">{{ logoutReason }}</p> <a class=\"button color-white\" href=\"#/login\">Log In</a> </div> ";
// Exports
export default code;